import React from 'react';
import { Notice, Flex, Spinner } from '@applyboard/crystal-ui';
import { useErrorHandler } from '~/hooks/useErrorHandler';
import { Application } from '~/pages/ApplicationDetails/data/useApplicationsByPassport';
import { useUniqueApplicationsListContext } from '../../../context/UniqueApplicationsListProvider';

export function UniqueApplicationsNotice({ onViewTableClick }: { onViewTableClick: () => void }) {
  const { apiError } = useErrorHandler();
  const { applications, isFetchingApplications, isApplicationsError } = useUniqueApplicationsListContext();

  React.useEffect(() => {
    if (isApplicationsError) {
      apiError();
    }
  }, [isApplicationsError, apiError]);

  const notice =
    'It appears that the applicant has submitted one or more other applications for current or future intakes.';

  function showNotice(applications: Application[], isFetchingApplications: boolean) {
    if (isFetchingApplications) {
      return (
        <Flex direction="column" align="center">
          <Flex>
            <Spinner />
          </Flex>
        </Flex>
      );
    } else if (!isFetchingApplications && applications.length === 0) {
      return <div></div>;
    } else {
      return (
        <Notice intent="warning" width="fill">
          {notice}
          <Notice.Button
            onClick={() => {
              onViewTableClick();
            }}
          >
            View Applications
          </Notice.Button>
        </Notice>
      );
    }
  }

  return showNotice(applications, isFetchingApplications);
}
